import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { UserService } from "./user.service";
import { IUsers } from "./iusers";

@Injectable({
    providedIn: 'root'
})
export class UsersResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _usersservice: UserService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, users: IUsers[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._usersservice.getAllUsers(data);
    }
}